export * from "modules/TyresDashboard/components/TyreModal";
export * from "modules/TyresDashboard/components/TyresDashboardFilters";
export * from "modules/TyresDashboard/components/TyresDashboardTable";
